module.exports = __webpack_public_path__ + "img/send.39234e98.svg";